import { ApiError } from '../../../shared/shared.api';

/** The API's own sentence for a refusal (a failed connection test is a 422 whose message is the vendor's reason), else `fallback`. */
export function apiErrorReason(err: unknown, fallback: string): string {
  if (!(err instanceof ApiError) || typeof err.body !== 'object' || err.body === null) return fallback;
  const message = (err.body as { message?: unknown }).message;
  if (typeof message === 'string') return message;
  return fallback;
}
